import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { MenuBar } from "../../components/Menu/Menu";
import { getCurrentMeeting, reject_with_note } from "../../store/actions/meeting.action";
import { Button } from "@material-tailwind/react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import MeetingParticipantProfile from "../../components/users/MeetingParticipantProfile";

export default function RejectWithNote() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [menuOpen, setMenuOpen] = useState(false);
  const [comment, setComment] = useState("");
  const token = localStorage.getItem("token");
  const mail = localStorage.getItem("mail");
  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
  const navigation = useNavigate();

  useEffect(() => {
    dispatch(getCurrentMeeting({ token, id }));
  }, [dispatch, token, mail, id]);

  const closeMenuBar = () => {
    setMenuOpen(false);
  };

  const openMenuBar = () => {
    setMenuOpen(true);
  };

  const sendReject = () => {

    if (comment.length < 10) {
    toast.warn(t("review.comment_too_short"), {
      position: "bottom-right",
    });
    return;
    }

    dispatch(
      reject_with_note({
        token,
        id,
        comment,
      })
    );
    navigation("/user/meetings");
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1; // Months are zero-indexed
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    const formattedDate = `${day}/${month}/${year}`;
    const formattedTime = `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;

    return `${formattedDate} ${formattedTime}`;
  };

  return (
    <div className="max-w-screen-2xl mx-auto p-4 h-full">
      <Header openMenu={openMenuBar} />
      {/* {currentLeaderUser && currentMeeting && ( */}
      <>
        <div className="flex flex-col md:flex-row">
          <div className="basis-1/2">
            <MeetingParticipantProfile 
              meeting={currentMeeting} 
              t={t} 
              formatDateTime={formatDateTime}
              showMeetingDetails={true}
            />
          </div>
          <div className="basis-1/2 flex flex-col items-center justify-center gap-8">
            <p className="text-center text-xl md:text-2xl xl:text-3xl">
              {t("reject_with_note.write_reject_note")}
            </p>
            <textarea
              label="Message"
              className="w-[280px] h-[200px] bg-[var(--bg)] border-[2px] border-black p-2"
              value={comment}
              max={5}
              onChange={(e) => setComment(e.target.value)}
            />
            <Button
              color="red"
              onClick={() => {
                sendReject();
              }}
            >
              {t("reject_with_note.reject_button")}
            </Button>
          </div>
        </div>
      </>
      {/* )} */}
      <Footer />
      <MenuBar open={menuOpen} close={closeMenuBar} />
    </div>
  );
}
